import application from 'application/application';

import moment from 'moment';

application.directive('ngDatePicker', [
	'$timeout',
	'$stateParams',
	($timeout, $stateParams) => ({
		restrict: 'A',
		scope: {
			ngDatePickerMax: '=',
			ngDatePickerMin: '=',
			ngDatePickerStart: '=',
			ngDatePickerEnd: '=',
			ngDatePickerFormat: '=',
			ngDatePickerMaxRange: '=',
			ngStartOpen: '=',
			ngModel: '=',
			ngChange: '&'
		},
		link(scope, element) {
			let options = {
				autoApply: true,
				autoUpdateInput: true,
				locale: {
					separator: ' até ',
					daysOfWeek: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
					monthNames: [
						'Janeiro',
						'Fevereiro',
						'Março',
						'Abril',
						'Maio',
						'Junho',
						'Julho',
						'Agosto',
						'Setembro',
						'Outubro',
						'Novembro',
						'Dezembro'
					]
				}
			};

			if (scope.ngDatePickerMin) options.minDate = scope.ngDatePickerMin;

			if (scope.ngDatePickerMax) options.maxDate = scope.ngDatePickerMax;

			options.startDate = scope.ngDatePickerStart || moment();

			options.endDate = scope.ngDatePickerEnd || moment().subtract(1, 'day');

			if (scope.ngDatePickerFormat)
				options.locale.format = scope.ngDatePickerFormat;

			if (scope.ngDatePickerMaxRange)
				options.maxSpan = {
					days: scope.ngDatePickerMaxRange
				};

			$(element).daterangepicker(options, (start, end) => {
				scope.ngModel = [start.format(), end.format()];
			});

			if (scope.ngStartOpen) {
				let dp = $(element).data('daterangepicker');

				$timeout(() => {
					let validateElementDatePicker = $(element).data('daterangepicker');

					if (validateElementDatePicker) {
						let dataInicial, dataInicialFormat, dataFinal, dataFinalFormat;

						if (options != undefined && options.startDate) {
							if ($stateParams.dataHoraInicial) {
								dataInicial = new Date($stateParams.dataHoraInicial);

								dataInicialFormat = new Date(
									dataInicial.getFullYear(),
									dataInicial.getMonth(),
									dataInicial.getDate()
								);
							}

							if ($stateParams.dataHoraFinal) {
								dataFinal = new Date($stateParams.dataHoraFinal);

								dataFinalFormat = new Date(
									dataFinal.getFullYear(),
									dataFinal.getMonth(),
									dataFinal.getDate()
								);
							}

							if ($(element)) {
								$(element)
									.data('daterangepicker')
									.setStartDate(dataInicialFormat);

								$(element)
									.data('daterangepicker')
									.setEndDate(dataFinalFormat);
							}

							if (!$stateParams.dataHoraInicial) dp.show();
						}
					}
				}, 500);
			}

			$(element).on('showCalendar.daterangepicker', () => {
				let values;

				if ($(element).attr('value')) {
					values = JSON.parse($(element).attr('value'));

					values.rangeDataInicio = values.rangeDataInicio
						? values.rangeDataInicio
						: values.dataHoraInicial;
					values.rangeDataFim = values.rangeDataFim
						? values.rangeDataFim
						: values.dataHoraFinal;

					let dataInicial, dataInicialFormat, dataFinal, dataFinalFormat;

					if (values != undefined && values.rangeDataInicio) {
						dataInicial = new Date(values.rangeDataInicio);

						dataInicialFormat = new Date(
							dataInicial.getFullYear(),
							dataInicial.getMonth(),
							dataInicial.getDate()
						);

						dataFinal = new Date(values.rangeDataFim);

						dataFinalFormat = new Date(
							dataFinal.getFullYear(),
							dataFinal.getMonth(),
							dataFinal.getDate()
						);
					}

					if (values != undefined && values.dataInicial) {
						dataInicial = new Date(values.dataInicial);

						dataInicialFormat = new Date(
							dataInicial.getFullYear(),
							dataInicial.getMonth(),
							dataInicial.getDate()
						);

						dataFinal = new Date(values.dataFinal);

						dataFinalFormat = new Date(
							dataFinal.getFullYear(),
							dataFinal.getMonth(),
							dataFinal.getDate()
						);
					}

					$(element).daterangepicker(options, (start, end) => {
						scope.ngModel = [start.format(), end.format()];
					});

					$(element)
						.data('daterangepicker')
						.setStartDate(dataInicialFormat);

					$(element)
						.data('daterangepicker')
						.setEndDate(dataFinalFormat);

					scope.$apply();

					$(element).on('apply.daterangepicker', (ev, picker) => {
						// scope.$apply();

						$(this).val(
							picker.startDate.format('DD/MM/YYYY') +
								' até ' +
								picker.endDate.format('DD/MM/YYYY')
						);

						scope.$apply();

						scope.ngChange();
					});
				}
			});

			$timeout(() => {
				$(element).on('apply.daterangepicker', () => {
					scope.$apply();

					scope.ngChange();
				});
			});
		}
	})
]);
